import React from 'react';
import Image from 'next/image';
import styles from './SuccessPopup.module.scss';
import CloseBtn from '../../../assets/images/CloseBtn.svg';
import SubmittedLottie from '../../../assets/images/Feedback_Submitted.gif';

function SuccessPopup(props) {
  const { show, closePopup, popupMsg } = props;
  return (
    <div
      className={show ? styles.successPopupVisible : styles.successPopupHidden}
    >
      <div className={styles.successPopupCard}>
        <div
          className={styles.closeBtn}
          onClick={closePopup}
        >
          <CloseBtn />
        </div>
        <div className={styles.contentWrapper}>
          <div>
            <Image
              src={SubmittedLottie}
              width={140}
              height={140}
              alt="Submitted Lottie"
            />
          </div>
          <div className={styles.successText}>
            Request submitted successfully!
          </div>
          <div className={styles.supportText}>
            {/* Our support team will respond you on your registered email address
            shortly! */}
            {popupMsg}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessPopup;
